import React from "react";
import { useSelector } from "react-redux";
import TableWithCustomSearch from "../../../../components/table/coreUiTableWithCustomSearchAndDateConversion/TableWithCustomSearch";

const DetailsTable = () => {
  const {
    data = [],
    col_headers = [],
    columns,
    raw_data_link,
    links
  } = useSelector((state) => state.staffGrossSales.tableInfo);

  return (
    <TableWithCustomSearch
      fileName="staff-gross-sales"
      data={data}
      rawDataLink={raw_data_link}
      colHeaders={col_headers}
      columns={columns}
      links={links}
    />
  );
};

export default DetailsTable;
